import type { FC, ReactNode } from 'react';
import type { IconComponentProps } from '@THC/components/Icon';
import { CameraIcon } from '@THC/components/Icons/Camera';
import { ClassifiedIcon } from '@THC/components/Icons/Classified';
import { DamageMissingTrimIcon } from '@THC/components/Icons/DamageMissingTrim';
import { VehicleFrontIcon } from '@THC/components/Icons/VehicleFront';
import { VehicleTyreTreadIcon } from '@THC/components/Icons/VehicleTyreTread';
import { VehicleWheelIcon } from '@THC/components/Icons/VehicleWheel';
import { MDText } from 'i18n-react';

import LocalTexts from './Empty.text';

const LocalT = new MDText(LocalTexts);

interface EmptyItems {
	Icon: FC<IconComponentProps>;
	text: ReactNode;
}

export const CONTENT: Record<string, EmptyItems> = {
	damage: {
		Icon: DamageMissingTrimIcon,
		text: LocalT.translate('damage'),
	},
	documents: {
		Icon: ClassifiedIcon,
		text: LocalT.translate('documents'),
	},
	other: {
		Icon: CameraIcon,
		text: LocalT.translate('other'),
	},
	tyres: {
		Icon: VehicleTyreTreadIcon,
		text: LocalT.translate('tyres'),
	},
	vehicle: {
		Icon: VehicleFrontIcon,
		text: LocalT.translate('vehicle'),
	},
	wheels: {
		Icon: VehicleWheelIcon,
		text: LocalT.translate('wheels'),
	},
};
